import type { ReactNode } from 'react';
import { MiniSparkline } from '../charts/MiniSparkline';
import { InfoTip } from './InfoTip';
import styles from './StatCard.module.css';

interface StatCardProps {
  label: string;
  value: string | number;
  sub?: string;
  color?: string;
  icon?: ReactNode;
  trend?: { value: string; direction: 'up' | 'down' | 'flat' };
  sparklineData?: number[];
  onClick?: () => void;
  tooltip?: string;
}

export function StatCard({ label, value, sub, color, icon, trend, sparklineData, onClick, tooltip }: StatCardProps) {
  const trendClass = trend
    ? trend.direction === 'up' ? styles.trendUp
    : trend.direction === 'down' ? styles.trendDown
    : styles.trendFlat
    : '';

  const trendArrow = trend
    ? trend.direction === 'up' ? '\u2191'
    : trend.direction === 'down' ? '\u2193'
    : '\u2192'
    : '';

  return (
    <div
      className={`${styles.card} ${onClick ? styles.clickable : ''}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
    >
      <div className={styles.top}>
        <div className={styles.content}>
          <div className={styles.label}>{label}{tooltip && <InfoTip text={tooltip} />}</div>
          <div className={styles.valueRow}>
            <div className={styles.value} style={color ? { color } : undefined}>
              {value}
            </div>
            {trend && (
              <span className={`${styles.trend} ${trendClass}`}>
                {trendArrow} {trend.value}
              </span>
            )}
          </div>
          {sub && <div className={styles.sub}>{sub}</div>}
        </div>
        {icon && <div className={styles.icon}>{icon}</div>}
      </div>
      {sparklineData && sparklineData.length > 1 && (
        <div className={styles.sparkline}>
          <MiniSparkline data={sparklineData} color={color} />
        </div>
      )}
    </div>
  );
}
